// Detecta domínios de e-mail claramente digitados errado antes de gastar
// um envio de e-mail de confirmação (que nunca chegaria ao destinatário).

const COMMON_DOMAINS = [
  "gmail.com",
  "hotmail.com",
  "outlook.com",
  "icloud.com",
  "yahoo.com",
  "yahoo.com.br",
  "live.com",
  "bol.com.br",
  "uol.com.br",
  "terra.com.br",
  "globo.com",
  "me.com",
  "protonmail.com",
];

// Erros de digitação frequentes observados na base.
const EXPLICIT_TYPOS: Record<string, string> = {
  "gmail.con": "gmail.com",
  "gmail.co": "gmail.com",
  "gmail.cm": "gmail.com",
  "gmail.com.br": "gmail.com",
  "gmal.com": "gmail.com",
  "gmial.com": "gmail.com",
  "gmai.com": "gmail.com",
  "gemail.com": "gmail.com",
  "gmail.vom": "gmail.com",
  "hotmial.com": "hotmail.com",
  "hotmai.com": "hotmail.com",
  "hotmail.con": "hotmail.com",
  "hotmail.co": "hotmail.com",
  "hormail.com": "hotmail.com",
  "outlok.com": "outlook.com",
  "outlook.con": "outlook.com",
  "outllok.com": "outlook.com",
  "icloud.con": "icloud.com",
  "iclound.com": "icloud.com",
  "yaho.com": "yahoo.com",
  "yahoo.con": "yahoo.com",
};

function editDistance(a: string, b: string): number {
  const m = a.length;
  const n = b.length;
  let prev = Array.from({ length: n + 1 }, (_, i) => i);
  for (let i = 1; i <= m; i++) {
    const curr = [i];
    for (let j = 1; j <= n; j++) {
      curr[j] = Math.min(
        prev[j] + 1,
        curr[j - 1] + 1,
        prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1),
      );
    }
    prev = curr;
  }
  return prev[n];
}

/**
 * Retorna o domínio correto sugerido, ou null se o e-mail parece válido.
 */
export function suggestEmailDomain(email: string): string | null {
  const clean = (email || "").trim().toLowerCase();
  const at = clean.lastIndexOf("@");
  if (at < 1 || at === clean.length - 1) return null;

  const domain = clean.slice(at + 1);
  if (COMMON_DOMAINS.includes(domain)) return null;

  const explicit = EXPLICIT_TYPOS[domain];
  if (explicit) return explicit;

  // Domínios corporativos legítimos são muitos — só sugerimos quando o
  // domínio está a 1 caractere de distância de um domínio muito comum.
  for (const candidate of COMMON_DOMAINS) {
    if (editDistance(domain, candidate) === 1) return candidate;
  }

  return null;
}

/**
 * Mensagem pronta para exibir ao usuário, ou null se não há problema.
 */
export function emailTypoMessage(email: string): string | null {
  const suggestion = suggestEmailDomain(email);
  if (!suggestion) return null;
  const local = email.trim().toLowerCase().split("@")[0];
  return `Você quis dizer ${local}@${suggestion}?`;
}
